import React from 'react';

const CrossIcon = () => {
    return (
        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.65625 1.34375L1.34375 8.65625M1.34375 1.34375L8.65625 8.65625" stroke="current" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
};

export default CrossIcon;